import { TextTemplateType } from '@shared/enums/TextTemplateType';
import { IValueLanguage } from '@shared/models/language.model';
import { IContentLanguage } from '@shared/models/multilanguage-model';
import { ILanguage, ILanguages } from '@shared/services/api/legacy/languages-service/languages-model';
import { ITemplateSurveyQuestion } from '@shared/services/api/legacy/survey-service/survey-model';

export interface ITextTemplate {
    type: TextTemplateType;
    languages: ILanguages;
    contentLanguages: IContentLanguage[];
}

export class TextTemplate implements ITextTemplate {
    public type: TextTemplateType;
    public languages: ILanguages;
    public contentLanguages: IContentLanguage[];
}

export interface IDocumentTemplate {
    id?: string;
    height: number;
    width: number;
    documentType: number;
    documentSizeType: number;
    documentSections: IDocumentSection[];
    documentLanguages: ILanguage[];
    documentNames: IValueLanguage[];
    languageId?: string;
}

export class DocumentTemplate implements IDocumentTemplate {
    public id?: string;
    public height: number;
    public width: number;
    public documentType: number;
    public documentSizeType: number;
    public documentSections: IDocumentSection[];
    public documentLanguages: ILanguage[];
    public documentNames: IValueLanguage[];
    public languageId?: string;
}

export interface IAddDocumentTemplate {
    height: number;
    width: number;
    documentType: number;
    documentSizeType: number;
    documentSections: IDocumentSection[];
    documentLanguages: ILanguage[];
    documentNames: IValueLanguage[];
}

export class AddDocumentTemplate implements IAddDocumentTemplate {
    constructor(
        public height: number,
        public width: number,
        public documentType: number,
        public documentSizeType: number,
        public documentSections: IDocumentSection[],
        public documentLanguages: ILanguage[],
        public documentNames: IValueLanguage[],
    ) { }
}

export interface IUpdateDocumentTemplate {
    id: string;
    height: number;
    width: number;
    documentType: number;
    documentSizeType: number;
    documentSections: IDocumentSection[];
    documentLanguages: ILanguage[];
    documentNames: IValueLanguage[];
}

export class UpdateDocumentTemplate implements IAddDocumentTemplate {
    constructor(
        public id: string,
        public height: number,
        public width: number,
        public documentType: number,
        public documentSizeType: number,
        public documentSections: IDocumentSection[],
        public documentLanguages: ILanguage[],
        public documentNames: IValueLanguage[],
    ) { }
}

export interface IDocumentSection {
    backgroundColor: string;
    documentSectionType: number;
    documentContents: IValueLanguage[];
    height: number;
    index: number;
    showQrCode?: boolean;
    showBarCode?: boolean;
    codeWidth?: number;
    codeHeight?: number;
}

export interface IDocumentTranslation {
    isDefault: boolean;
    languageId: string;
}

export interface ITicketTextTemplate {
    languages: ILanguages;
    textTemplatesDictionary: {
        [key in TextTemplateType]?: IContentLanguage[];
    };
}

export class TicketTextTemplate implements ITicketTextTemplate {
    public languages: ILanguages;
    public textTemplatesDictionary: {
        [key in TextTemplateType]?: IContentLanguage[];
    };
}

export interface ISurveyTemplateList {
    surveyTemplates: ISurveyTemplateListItem[];
}
export interface ISurveyTemplateListItem {
    id: string;
    isActive: boolean;
    surveyTemplateTranslations: ITranslation[];
    name: string;
}

export interface ISurveyTemplate {
    id: string;
    isActive: boolean;
    surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[];
    translations: ITranslation[];
}

export interface ISurveyTemplateResp {
    surveyTemplate: {
        id: string;
        isActive: boolean;
        surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[];
        translations: ITranslation[];
    };
}

export class SurveyTemplate implements ISurveyTemplate {
    constructor(
        public id: string,
        public isActive: boolean,
        public surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[],
        public translations: ITranslation[]
    ) { }
}

export interface IAddSurveyTemplate {
    id: string;
    isActive: boolean;
    surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[];
    translations: ITranslation[];
}

export class AddSurveyTemplate implements IAddSurveyTemplate {
    constructor(
        public id: string,
        public isActive: boolean,
        public surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[],
        public translations: ITranslation[]
    ) { }
}

export interface IUpdateSurveyTemplate {
    id: string;
    surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[];
    translations: ITranslation[];
    surveyTemplateSurveyQuestionToDelete: string[];
    subQuestionToDelete: string[];
}

export class UpdateSurveyTemplate implements IUpdateSurveyTemplate {
    constructor(
        public id: string,
        public surveyTemplateSurveyQuestions: ITemplateSurveyQuestion[],
        public translations: ITranslation[],
        public surveyTemplateSurveyQuestionToDelete: string[],
        public subQuestionToDelete: string[]
    ) { }
}

export interface ITranslation {
    id: string;
    value: string;
    languageId: string;
}
